export default "__VITE_ASSET__1e39579e__"